import { ServiceListItem } from './service';

export interface CreateServiceGroupDto {
  name: string,
  serviceIds: number[],
}

export interface CreateServiceGroup {
  name: string,
  services: ServiceListItem[],
}

export interface UpdateServiceGroupDto extends CreateServiceGroupDto {
  enabled: boolean,
}

export interface UpdateServiceGroup extends CreateServiceGroup {
  enabled: boolean,
}


export interface ServiceGroupDto {
  id: number,
  name: string,
  enabled: boolean,
  deletedAt: Date,
  readonly: boolean,
  services: ServiceListItem[]
}

export interface ServiceGroup {
  id: number,
  name: string,
  enabled: boolean,
  deletedAt: Date,
  readonly: boolean,
  services: ServiceListItem[]
}

export function createServiceGroupToDto(createServiceGroup: CreateServiceGroup): CreateServiceGroupDto {
  return {
    name: createServiceGroup.name,
    serviceIds: createServiceGroup.services.map(({id}) => id)
  }
}

export function updateServiceGroupToDto(updateServiceGroup: UpdateServiceGroup): UpdateServiceGroupDto {
  return {
    name: updateServiceGroup.name,
    serviceIds: updateServiceGroup.services.map(({id}) => id),
    enabled: updateServiceGroup.enabled,
  }
}

export function serviceGroupDtoToDomain(serviceGroupDto: ServiceGroupDto): ServiceGroup {
  return {
    ...serviceGroupDto,
  }
}
